import React from 'react'
import HomeComponent from '../components/home/HomeComponent'


const Home = () => (
  <HomeComponent/>
)
export default Home
